<template>
    <div>
        <b-breadcrumb :items="items"/>
        <form class="container-fluid" style="background-color: white">
            <div class="row mt-2">
                <table width="100%">
                    <thead>
                    <tr>
                        <th>วันที่สร้างโควต้า</th>
                        <th>รหัสโควต้า</th>
                        <th>นำเข้ายอดจริง(เศษ)</th>
                        <th>เศษคงเหลือ</th>
                        <!--                        <th>เศษเมื่อวาน</th>-->
                        <!--                        <th>โควต้าหมดอายุ(เมื่อวาน)</th>-->
                        <th>โควต้าหมดอายุ</th>
                        <th>รวมสต๊อกเซลล์</th>
                        <th>แบ่งจำนวนโควต้า/เซลล์</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(x,i) in list" :key="i">
                        <td>{{ x.created_at | moment('DD/MM/YYYY') }}</td>
                        <td>{{ x.quota ? x.quota.no : '' }}</td>
                        <td>
                            {{ x.quota ? x.quota.real_stock : '' }}{{ x.quota && x.quota.remain_ytd ? '(' + x.quota.remain_ytd + ')' : '' }}
                        </td>
                        <td>{{ x.quota ? x.quota.remain : '' }}</td>
                        <td>{{ x.quota ? x.quota.remain_expire : '' }}</td>
                        <td>{{ x.quota ? x.quota.real_stock + x.quota.remain : '' }}</td>
                        <td>{{ x.limit }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </form>
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";

export default {
    name: "quota-list",
    components: {
        Multiselect
    },
    created() {
        this.$store.dispatch('Seller/quotaSaleShow', this.$route.params.id).then(res => {
            this.list = res;
            // //console.log(res)
        });
    },
    data() {
        return {
            items: [
                {
                    text: "ตั้งค่าโควต้า",
                    to: {name: "quota-config"}
                },
                {
                    text: "รายละเอียด",
                    active: true
                }
            ],
            list: [],
        }
    },
    computed: {
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
        }),
    },
    methods: {}

}
</script>

<style scoped>
.text-bold {
    font-weight: bold;
}

thead tr {
    background-color: #ffbf00;
    color: white;
}

thead td {
    color: black;
    background-color: #ebebe0;
}
</style>
